import { render, staticRenderFns } from "./editPill.vue?vue&type=template&id=786126da"
import script from "./editPill.vue?vue&type=script&lang=js"
export * from "./editPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports